"use strict";

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateFilterButton = exports.DateFilterMode = exports.convertFromDateFilterInput = exports.convertToDateFilterInput = void 0;

var antd_1 = require("antd");

var iconoir_react_1 = require("iconoir-react");

var moment_1 = __importDefault(require("moment"));

var react_1 = __importDefault(require("react"));

var Block_1 = require("./Block");

var DateTime_1 = require("./DateTime");

var constants_1 = require("./constants");

var styledTypes_1 = require("./styledTypes");

function convertToDateFilterInput(value) {
  if (value.mode === DateFilterMode.Before) return {
    before: value.date
  };else return {
    after: value.date
  };
}

exports.convertToDateFilterInput = convertToDateFilterInput;

function convertFromDateFilterInput(input) {
  if (input.before) return {
    date: input.before,
    mode: DateFilterMode.Before
  };else if (input.after) return {
    date: input.after,
    mode: DateFilterMode.After
  };else return undefined;
}

exports.convertFromDateFilterInput = convertFromDateFilterInput;
var DateFilterMode;

(function (DateFilterMode) {
  DateFilterMode["Before"] = "BEFORE";
  DateFilterMode["After"] = "AFTER";
})(DateFilterMode = exports.DateFilterMode || (exports.DateFilterMode = {}));

function DateFilterButton(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Date' : _ref$label,
      _value = _ref.value,
      onChange = _ref.onChange,
      popoverProps = _ref.popoverProps,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? DefaultDateChildren : _ref$children;

  var _react_1$default$useS = react_1.default.useState(_value),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      value = _react_1$default$useS2[0],
      setValue = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(false),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      visible = _react_1$default$useS4[0],
      setVisible = _react_1$default$useS4[1];

  var theme = react_1.default.useContext(styledTypes_1.ThemeContext);
  react_1.default.useEffect(function () {
    setValue(_value);
  }, [_value]);
  return react_1.default.createElement(antd_1.Popover, Object.assign({
    trigger: ['click'],
    title: "Filter ".concat(label),
    overlayStyle: {
      width: 400
    }
  }, popoverProps, {
    visible: visible,
    onVisibleChange: setVisible,
    children: children({
      onClick: function onClick() {
        return setVisible(true);
      },
      label: label,
      valueLabel: _value ? "".concat(_value.mode.toLowerCase(), " ").concat((0, moment_1.default)(_value.date).format(constants_1.DATE_FORMATS.FULL)) : undefined
    }),
    content: react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Block_1.HSpaced, {
      style: {
        width: '100%'
      }
    }, react_1.default.createElement(antd_1.Select, {
      options: [{
        value: DateFilterMode.Before,
        label: 'Before'
      }, {
        value: DateFilterMode.After,
        label: 'After'
      }],
      onChange: function onChange(mode) {
        return setValue({
          mode: mode,
          date: (value === null || value === void 0 ? void 0 : value.date) || (0, moment_1.default)().format()
        });
      },
      value: (value === null || value === void 0 ? void 0 : value.mode) || DateFilterMode.After
    }), react_1.default.createElement("div", {
      style: {
        flex: 1
      }
    }, react_1.default.createElement(DateTime_1.DateTimePicker, {
      value: (value === null || value === void 0 ? void 0 : value.date) ? (0, moment_1.default)(value.date).format(constants_1.DATE_FORMATS.TEXT) : undefined,
      onChange: function onChange(date) {
        setValue({
          mode: (value === null || value === void 0 ? void 0 : value.mode) || DateFilterMode.After,
          date: (0, moment_1.default)(date).format()
        });
      },
      inputProps: {
        placeholder: "Pick a ".concat(label),
        style: {
          flex: 1
        }
      }
    })), react_1.default.createElement(antd_1.Button, {
      type: 'primary',
      icon: react_1.default.createElement(iconoir_react_1.Check, null),
      disabled: !(value === null || value === void 0 ? void 0 : value.date) || !(value === null || value === void 0 ? void 0 : value.mode),
      onClick: function onClick() {
        onChange(value);
        setVisible(false);
      }
    })), value ? react_1.default.createElement(antd_1.Button, {
      type: 'default',
      style: {
        display: 'block',
        marginLeft: 'auto',
        marginTop: theme['@size-s']
      },
      onClick: function onClick() {
        setValue(undefined);
        onChange(undefined);
        setVisible(false);
      }
    }, "Clear Filter") : null)
  }));
}

exports.DateFilterButton = DateFilterButton;

function DefaultDateChildren(_ref2) {
  var onClick = _ref2.onClick,
      valueLabel = _ref2.valueLabel,
      label = _ref2.label;
  return react_1.default.createElement(antd_1.Button, {
    type: valueLabel ? 'primary' : 'default',
    onClick: onClick,
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, valueLabel ? "".concat(label, " ").concat(valueLabel) : "Filter ".concat(label), "\xA0", react_1.default.createElement(iconoir_react_1.NavArrowDown, null));
}